import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../lib/utils'

const toastVariants = cva(
  // 하단탭을 가리지 않게 그 위로 띄운다
  'fixed left-1/2 bottom-[calc(env(safe-area-inset-bottom)+5rem)] z-[60] -translate-x-1/2 rounded-lg px-4 py-3 text-sm font-semibold text-white shadow-lg',
  {
    variants: {
      variant: {
        success: 'bg-[var(--color-success)]',
        error: 'bg-[var(--color-danger)]',
        warning: 'bg-[var(--color-warning)]',
      },
    },
    defaultVariants: { variant: 'success' },
  },
)

interface Props extends VariantProps<typeof toastVariants> {
  message: string
  /** 0 이면 자동으로 사라지지 않는다 */
  duration?: number
  onClose?: () => void
}

export function Toast({ message, variant, duration = 3000, onClose }: Props) {
  useEffect(() => {
    if (duration <= 0) return
    const t = setTimeout(() => onClose?.(), duration)
    return () => clearTimeout(t)
  }, [duration, onClose, message])

  if (!message || typeof document === 'undefined') return null

  return createPortal(
    <div role="status" aria-live="polite" className={cn(toastVariants({ variant }))}>
      {message}
    </div>,
    document.body,
  )
}
